import 'reflect-metadata';
import { inject, injectable } from 'inversify';
import {
  YoutubeOptimizerPort,
  YoutubeOptimizerResult,
} from '../../../core/port/youtube-optimizer.port.ts';
import INJECTION_TOKENS from '../../../core/generic/ioc/injection-tokens.ts';
import type SimpleHttpService from '../../../core/generic/simple-http-service.port.ts';

@injectable()
export class YoutubeOptimizerApiRepository implements YoutubeOptimizerPort {
  constructor(
    @inject(INJECTION_TOKENS.DV360_API_HTTP_SERVICE)
    private readonly httpService: SimpleHttpService
  ) {}

  async checkAndLaunchPerformanceOptimizer(): Promise<YoutubeOptimizerResult> {
    try {
      const response = await this.httpService.post<YoutubeOptimizerResult>(
        'v1/youtube/check-and-launch-performance-optimizer',
        {}
      );

      return response;
    } catch (error) {
      console.error('Error calling YouTube performance optimizer:', error);
      throw new Error('Failed to launch YouTube performance optimizer');
    }
  }
}
